import React, { Component } from "react";
import axios from "axios";
import { Buffer } from "buffer";

import {
   MDBContainer,
   MDBSpinner,
   MDBBtn,
   MDBFile,
   MDBTable,
   MDBTableHead
} from "mdb-react-ui-kit";

class UploadMasterData extends Component {
   showContainer = () => {
      const selectedValue = document.querySelector(".upload-master-data-select").value;
      const formContainerStyle = document.querySelector(".form-container").style;
      const flagContainer = document.querySelector(".action-flag-container");
      const formLabel = document.querySelector(".form-label");
      if (selectedValue === "select") {
         formLabel.textContent = "Master Data Input";
         formContainerStyle.display = "none";
         flagContainer.display = "none";
      } else if (selectedValue === "labor_code") {
         formLabel.textContent = "Labor Master Data Input";
         formContainerStyle.display = "flex";
         flagContainer.classList.add("d-none");
      } else {
         if (selectedValue === "customer")
            flagContainer.classList.remove("d-none");
         else
            flagContainer.classList.add("d-none");
         formLabel.textContent = selectedValue[0].toUpperCase() + selectedValue.substring(1) + " Master Data Input";
         formContainerStyle.display = "flex";
      }
   };

   uploadMasterData = async () => {
      let formData = new FormData();
      let files = document.querySelector(".master-data-input").files;
      const fileErrorStyle = document.querySelector(".file-error").style;

      if (files.length !== 0) {
         fileErrorStyle.display = "none";
         const spinnerStyle = document.querySelector(".spinner").style;
         spinnerStyle.display = "flex";

         const uploadButton = document.querySelector(".upload-button");
         uploadButton.setAttribute("disabled", true);

         const uploadMasterSelect = document.querySelector(".upload-master-data-select");
         let file = files[0];

         if (uploadMasterSelect.selectedIndex !== 0) {
            const url = `https://p4d-sutlej.kreativit.in:443/kitmyclients-apis/v1/business_data_uploader/RSCS/masters?name=${uploadMasterSelect.value + "_master"}`;
            if (file.name.slice(file.name.length - 3) === "csv") {
               formData.append("file", file);

               await axios(url, {
                  method: "POST",
                  data: formData,
                  headers: {
                     Authorization: "Basic " + Buffer.from("RSCS_admin:admin@scsr").toString("base64"),
                     "Auth-Token": "5905d234-34f7-53ce-b192-a886192134ca",
                     "Content-Type": "multipart/form-data",
                  }
               })
                  .then(res => res.data)
                  .then(resp => {
                     if (resp.code === 200) {
                        spinnerStyle.display = "none";
                        uploadButton.removeAttribute("disabled");
                        document.querySelector(".master-data-input").value = null;

                        setTimeout(function () {
                           alert("Uploaded Successfully");
                        }, 1000);
                     }
                  }).catch(err => console.log(err));
            } else {
               alert("File Not Supported\nSupported File Type(s): .csv");
            }
         }

         spinnerStyle.display = "none";
         uploadButton.removeAttribute("disabled");
      } else {
         fileErrorStyle.display = "inherit";
      }
   };

   render() {
      return (
         <MDBContainer className="d-flex flex-column justify-content-center align-items-center mt-5">
            <MDBContainer className="spinner" style={{ "display": "none" }} >
               <MDBSpinner className="me-2" color="dark" style={{ width: "5rem", height: "5rem" }}></MDBSpinner>
            </MDBContainer>

            <h2><u>Upload Master Data</u></h2>
            <div>
               <strong className="me-3">Master Type:</strong>
               <select className="upload-master-data-select my-3" onChange={this.showContainer}>
                  <option value="select">-- Select --</option>
                  <option value="customer">Customer Master</option>
                  <option value="part">Parts Master</option>
                  <option value="labor_code">Labor Master</option>
               </select>
            </div>

            <MDBTable className="action-flag-container mb-2 d-none" responsive bordered borderColor="primary" align="middle">
               <MDBTableHead>
                  <tr className="table-info">
                     <th>a - Add</th>
                     <th>n - No Action</th>
                     <th>u - Update</th>
                     <th>d - Delete</th>
                  </tr>
               </MDBTableHead>
            </MDBTable>

            <div className="form-container flex-column justify-content-center align-items-center" style={{ "display": "none" }}>
               <MDBFile label="Master Data Input" className="master-data-input" accept=".csv" />
               <span className="file-error" style={{ "display": "none", "color": "#f00" }}>Choose a file before proceeding</span>
               <MDBBtn className="upload-button my-3" onClick={this.uploadMasterData}>Upload</MDBBtn>
            </div>
         </MDBContainer>
      );
   }
}

export default UploadMasterData;
